var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOracleShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74316 12.2432C2.12402 12.2432 0 10.1221 0 7.50293C0 4.88379 2.12402 2.75684 4.74316 2.75684H10.2568C12.876 2.75684 15 4.88379 15 7.50293C15 10.1221 12.876 12.2432 10.2568 12.2432H4.74316ZM10.1338 10.5703C11.8301 10.5703 13.2041 9.19922 13.2041 7.50293C13.2041 5.80664 11.8301 4.42969 10.1338 4.42969H4.86621C3.16992 4.42969 1.7959 5.80664 1.7959 7.50293C1.7959 9.19922 3.16992 10.5703 4.86621 10.5703H10.1338Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracleShort);
export default __webpack_public_path__ + "static/media/Oracle-Short.eaadd613cd7d637bd7849be810690212.svg";
export { ForwardRef as ReactComponent };